import React from 'react'

interface Props {
  children: React.ReactNode
}

/**
 * A record list beside the page body. Sized to the list rather than to a share
 * of the viewport, which is what made it a quarter of the screen on a laptop.
 */
export const FullPageSidebar = (props: Props) => (
  <div className="flex h-full w-full flex-shrink-0 flex-col overflow-y-auto border-r border-mm-neutral-1-200 bg-white sm:w-72">
    {props.children}
  </div>
)
